// 获取当前最近的一个window，在ares_cms上是中间预览窗口的window
function getNowWindow() {
  let nowWindow = window;
  if (window.iframeWindow) {
    nowWindow = window.iframeWindow;
  }
  return nowWindow;
}

function rem2px(rem) {
  if (!rem) {
    return 0;
  }
  const nowWindow = getNowWindow();
  const nowDocument = nowWindow.document;
  const nowHtml = nowDocument.getElementsByTagName('html')[0];
  const { fontSize } = nowHtml.style;
  const fontSizeNum = Number(fontSize.substr(0, fontSize.length - 2));
  const remNum = Number(rem.substr(0, rem.length - 3));

  return remNum * fontSizeNum;
}

// 获取当前视图
function getScrollX() {
  const nowWindow = getNowWindow();
  const nowDocument = nowWindow.document;

  return nowWindow.pageXOffset !== undefined
    ? nowWindow.pageXOffset
    : (
      nowDocument.documentElement
        || nowDocument.body.parentNode
        || nowDocument.body
    ).scrollLeft;
}
function getScrollY() {
  const nowWindow = getNowWindow();
  const nowDocument = nowWindow.document;

  return nowWindow.pageYOffset !== undefined
    ? nowWindow.pageYOffset
    : (
      nowDocument.documentElement
        || nowDocument.body.parentNode
        || nowDocument.body
    ).scrollTop;
}

class PageScrollHandler {
  constructor() {
    this.compList = {};
  }
  scrollToComp(compId, { time = 0, offset = '0rem' }) {
    const el = this.compList[compId];
    if (!el) {
      return;
    }

    const offsetPx = rem2px(offset);
    const nowWindow = getNowWindow();
    const { left, top } = el.getBoundingClientRect();
    const startX = getScrollX();
    const startY = getScrollY();
    const distanceX = left;
    const distanceY = top + offsetPx;
    let offsetX = 0;
    let offsetY = 0;

    // 如果不需要动画
    if (!time) {
      nowWindow.scrollTo(startX + distanceX + 1, startY + distanceY + 1);
      return;
    }

    let lastTime = new Date();
    const timer = setInterval(() => {
      const now = new Date();
      const delta = (now - lastTime) / time;
      const deltaX = delta * distanceX;
      const delatY = delta * distanceY;
      lastTime = now;

      offsetX += deltaX;
      offsetY += delatY;

      const reach = Math.abs(offsetX) >= Math.abs(distanceX) || Math.abs(offsetY) >= Math.abs(distanceY);

      if (reach) {
        nowWindow.scrollTo((startX + distanceX) + 1, (startY + distanceY) + 1);
        clearInterval(timer);
      } else {
        nowWindow.scrollTo((startX + offsetX) + 1, (startY + offsetY) + 1);
      }
    }, 10);
  }
  addComp(el) {
    const compId = el.id;
    if (this.compList[compId]) {
      return;
    }
    this.compList[compId] = el;
  }
}

export default new PageScrollHandler();
